import { ReactElement, useEffect, useState } from 'react'
import Spinner from '../Spinner'
import { bg } from 'lib/background'
import { debug } from 'lib/logging'
import { run } from 'lib/run'
import { gqlFetchOne } from 'app/lib/graphqlClient'

let fetching: Record<string, Promise<string>> = {}
let cache: Record<string, string> = {}

export async function getName(campaignId: string, showUnknown: boolean = false) {
  if (cache[campaignId] != null) return cache[campaignId]
  if (fetching[campaignId] != null) return fetching[campaignId]
  else if (!campaignId || campaignId === `undefined`) return
  return (fetching[campaignId] = run(async () => {
    const fallback = showUnknown ? `Unknown` : ``
    try {
      const campaign = await gqlFetchOne(`campaign`, campaignId)
      debug(`utm`, `fetched ad campaign name`, campaignId)
      // A failed lookup is not cached, so the next render can try again.
      if (!campaign) return fallback
      return (cache[campaignId] = campaign.name || fallback)
    } finally {
      delete fetching[campaignId]
    }
  }))
}

export function LazyAdCampaign(props: {
  campaignId?: string
  className?: string
  loadingIndicator?: boolean
  showUnknown?: boolean
}): ReactElement {
  const [name, setName] = useState<string | undefined>(props.campaignId ? cache[props.campaignId] : undefined)
  useEffect(() => {
    if (props.campaignId === undefined) return
    if (name && cache[props.campaignId] === name) return
    else setName(``)
    bg(
      getName(props.campaignId, props.showUnknown).then((name) => {
        debug(`utm`, `set ad campaign name`, props.campaignId, { name })
        setName(name)
      }),
    )
  }, [props.campaignId])

  return name != null ? (
    <span className={props.className}>{name}</span>
  ) : props.campaignId && props.loadingIndicator !== false ? (
    <Spinner size={5} />
  ) : (
    <></>
  )
}
